//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

//local imports
import { CatalogConstants, ProgramModel } from "@app/catalog";
import { SearchModel } from "@app/core";
import { BreadcrumbChangedMessage, BreadcrumbItemToggleMessage, Messenger, PresenterType } from "@app/shared";

@PresenterType({
  model: ProgramModel,
  key: "tileBottom",
})
@Component({
  selector: 'program-carousel-item-bottom',
  standalone: false,
  templateUrl: './program-carousel-item-bottom.component.html',
  styleUrl: './program-carousel-item-bottom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgramCarouselItemBottomComponent implements OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private selectedPrograms: ProgramModel[] = [];
  private searchItems: SearchModel[] = [];

  public data: WritableSignal<ProgramModel> = signal<ProgramModel>(undefined);


  constructor(
    private messenger: Messenger
  ){
    this.messenger.subscribe(this, BreadcrumbChangedMessage, (message) => {
        if(message.breadcrumbName !== CatalogConstants.CATALOG) { 
            return;
        }
        message.breadcrumbs.forEach((item) => {
          if(item instanceof SearchModel) {
            const exists = this.searchItems.some(search => search.id === item.id);
            if (!exists) { 
            this.searchItems.push(item);
            }
          }

          if(item instanceof ProgramModel) {
            const exists = this.selectedPrograms.some(program => program.id === item.id);
            if (!exists) {
              this.selectedPrograms.push(item);
            }
          }
        })
    });
  }

  public navigateToDetailPage() {
    const currentProgram = this.data();

    this.searchItems.forEach((searchItem) => {
      this.messenger.send(new BreadcrumbItemToggleMessage(searchItem, CatalogConstants.CATALOG));
    });

    const isAlreadySelected = this.selectedPrograms.some(program => program.id === currentProgram.id);
    
    if (!isAlreadySelected) {
      this.messenger.send(new BreadcrumbItemToggleMessage(currentProgram, CatalogConstants.CATALOG));
    }

    const queryParams = {
      programId: currentProgram.id
    }

    this.router.navigate(["program", currentProgram.id], {
      relativeTo: this.route,
      queryParams
    });
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
